export default "__VITE_ASSET__3ad4ac93__"